import {updateTaskStatus} from 'app/subscriptions/slice';

import type {StoreType} from 'app/store/AppStore';
import type {TaskStatusWSMessageType} from 'app/subscriptions/types';

export function handleTaskStatus(
  event: string,
  {data}: {data: TaskStatusWSMessageType},
  sendMessage: unknown,
  store: StoreType
) {
  return store.dispatch(updateTaskStatus(data));
}
